import React from 'react'
import styled from '@emotion/styled/macro'
import mq from 'mediaQuery'
import ScrollToTop from 'components/ScrollToTop'
import { Link } from 'react-router-dom'

const TermsOfUse = () => (
  <ScrollToTop>
    <Wrapper>
      <Title>Terms Of Use</Title>

      <SubTitle>AGREEMENT TO TERMS</SubTitle>
      <Content>
        These Terms of Use constitute a legally binding agreement made between
        you, whether personally or on behalf of an entity (“you”, “your”,
        “customer”, “customers”) and W3D Domains, Inc., along with its agents,
        assigns, and affiliates "<strong>Company</strong>", “<strong>we</strong>
        ”, “<strong>us</strong>”, or “<strong>our</strong>”), concerning your
        access to and use of the w3ddomains.com website as well as any other
        media form, media channel, mobile website or mobile application related,
        linked, or otherwise connected thereto which is controlled by the
        Company (collectively, the “Site”). However, please note that blockchain
        networks, even if W3D Domains publishes Domain Names or other records to
        them, are controlled by third parties (who may be distributed networks
        of independent computers) and are therefore not included in the
        definition of the "Site”. As a user of the Site, you acknowledge that
        you have read, understood, and agreed to these Terms of Use. YOU MUST
        DISCONTINUE THE USE OF THE SITE IMMEDIATELY IF YOU DO NOT AGREE WITH ALL
        OF THESE TERMS OF USE.
        <br />
        <br />
        Supplemental terms and conditions or documents posted on the Site from
        time to time are hereby expressly incorporated herein by reference. We
        may make any changes or modifications to these Terms of Use at any time
        and for any reason. We will alert you about any changes by updating the
        “Last Updated” date of these Terms of Use, and you waive any right to
        receive specific notice of each such change. It is your responsibility
        to periodically review these Terms of Use to stay informed of updates.
        You will be subject to and will be deemed to have been made aware of and
        to have accepted the changes in any revised Terms of Use by your
        continued use of the Site after the date such revised Terms of Use are
        posted.
        <br />
        <br />
        In jurisdictions or countries where such distribution or use would be
        contrary to law or regulation or which would require us to register, we
        do not intend to distribute or use the information on the Site. It is
        the sole responsibility of those who choose to access the Site from
        other locations to comply with local laws if and to the extent such laws
        apply.
        <br />
        <br />
        The Site is intended for users who are at least 18 years old. Persons
        under the age of 18 are not permitted to use or register for the Site.
      </Content>

      <SubTitle>INTELLECTUAL PROPERTY RIGHTS</SubTitle>
      <Content>
        Unless otherwise indicated, the Site is our property, and all source
        code, databases, functionality, software, website designs, audio, video,
        text, photographs, and graphics on the Site (collectively, the
        “Content”) and the trademarks, service marks, and logos contained
        therein (the “Marks”) are owned or controlled by us or licensed to us,
        and are protected by copyright and trademark laws and various other
        intellectual property rights and unfair competition laws of the United
        States, foreign jurisdictions, and international conventions. The
        Content and the Marks are provided on the Site “AS IS” for your
        information and personal use only. Unless otherwise expressly permitted
        in these Terms of Use, no part of the Site and no Content or Marks may
        be copied, reproduced, aggregated, republished, uploaded, posted,
        publicly displayed, encoded, translated, transmitted, distributed, sold,
        licensed, or otherwise exploited for any commercial purpose.
        <br />
        <br />
        You are granted a limited license to access and use the Site, as well as
        to download or print a copy of any portion of the Content for your
        personal, non-commercial use. Our Site, the Content, and the Marks
        remain our property.
      </Content>

      <SubTitle>USER REPRESENTATIONS</SubTitle>
      <Content>
        By using the Site, you represent and warrant that: (1) all registration
        information you submit will be true, accurate, current, and complete;
        (2) you will maintain the accuracy of such information and promptly
        update such registration information as necessary; (3) you have the
        legal capacity, and you agree to comply with these Terms of Use; (4) you
        are not a minor in the jurisdiction in which you reside; (5) you will
        not access the Site through automated or non­human means, whether
        through a bot, script or otherwise; (6) you will not use the Site for
        any illegal or unauthorized purpose; and (7) your use of the Site will
        not violate any applicable law or regulation.
        <br />
        <br />
        If you provide any information that is untrue, inaccurate, not current,
        or incomplete, we have the right to suspend or terminate your account
        and refuse any and all current or future use of the Site (or any portion
        thereof).
      </Content>

      <SubTitle>USER REGISTRATION</SubTitle>
      <Content>
        You may be required to register with the Site. You agree to keep your
        password confidential and will be responsible for all use of your
        account and password. We reserve the right to remove, reclaim, or change
        a username you select if we determine, in our sole discretion, that such
        username is inappropriate, obscene, or otherwise objectionable.
      </Content>

      <SubTitle>PRODUCTS</SubTitle>
      <Content>
        There is no guarantee that all products will be available. For any
        reason, we reserve the right to discontinue any product. Additionally,
        we expressly reserve the right to develop new products at our sole
        discretion. All products are subject to change and are priced at our
        discretion.
      </Content>

      <SubTitle>PURCHASES AND PAYMENT</SubTitle>
      <Content>We accept the following forms of payment:</Content>
      <ul>
        <li>Visa</li>
        <li>Mastercard</li>
        <li>American Express</li>
        <li>Discover</li>
        <li>Select Cryptocurrency</li>
      </ul>
      <br />
      <br />
      <Content>
        You agree to provide current, complete, and accurate purchase and
        account information for all purchases made via the Site. You further
        agree to promptly update account and payment information, including
        email address, payment method, and payment card expiration date, so that
        we can complete your transactions and contact you as needed. Sales tax
        will be added to the price of purchases as deemed required by us. We may
        change prices at any time. All payments shall be in US dollars.
        <br />
        <br />
        By placing an order, you authorize us to charge your chosen payment
        provider for any such amounts at the prices then in effect. In the event
        your order is subject to recurring charges, you consent to our charging
        your payment method on a recurring basis without requiring your prior
        approval until you cancel the order. It is our policy to correct any
        errors or mistakes in pricing, regardless of whether we have already
        requested or received payment.
        <br />
        <br />
        At our sole discretion, we may refuse to sell any domain listed on the
        Site.
        <br />
        <br />
        If you place an order through the Site, we reserve the right to refuse
        it. In our sole discretion, we may limit or cancel quantities purchased
        per person, per household, or per order. These restrictions may apply to
        orders placed by the same customer account, orders using the same
        payment method, and/or orders shipping to the same address. If we
        believe an order was placed by a dealer, reseller, or distributor, we
        may limit or prohibit it.
      </Content>

      <SubTitle>REFUND POLICY</SubTitle>
      <Content>
        Except when stated otherwise in these Terms of Service, all fees for
        domain name registrations and related domain name Service(s) are
        refundable, for a full refund, within 14 days of purchase, with the
        exception of those domain name registrations and related domain name
        Service(s) purchased with crypto, for which a refund request must be
        made within 5 days of purchase. All refunds will be processed with the
        same payment method used to purchase the domain at the then-current spot
        rates for the USD value of your purchase at the time the refund is
        issued.
        <br />
        <br />
        <strong>
          All claim fees, blockchain fees, and other related fees will not be
          refunded; only the purchase price of your domain will be refunded.
        </strong>
        <br />
        <br />
        For any reason, W3D Domains reserves the right to refuse to sell you a
        domain name (or to complete such a sale once initiated).
        <br />
        <br />
        Domain fees from new domain name registrations may be refundable, at the
        sole discretion of W3D Domains, in the event of issues arising from
        actual or prospective trademark infringement or other abuses, “phishing”
        (the fraudulent practice of sending emails purporting to be from
        reputable companies or individuals to induce individuals to reveal
        personal information), technical limitations on name resolutions,
        mispriced sales (i.e., where the price should have been higher), and
        legal exigencies (i.e., court-ordered blocking or takeover of domain
        names, law enforcement-related reasons, etc.).
        <br />
        <br />
        All refunds shall be made to your profile on our website in the original
        payment method used or in-store credit.
        <br />
        <br />
        You are solely responsible for any fluctuations in exchange rates
        between other national currencies or cryptocurrencies between the time
        period of the original payment and the time of the subsequent refund.
        Card and PayPal payments will be refunded and processed in US dollars.
        <br />
        <br />
        Cryptocurrency payments will be refunded and processed in the same
        amount of USD as received: You are solely responsible for any
        fluctuations in the exchange rates between other national currencies and
        cryptocurrencies between when the original payment was made and when the
        refund is issued.
        <br />
        <br />
        As soon as a domain goes live on the blockchain and is transferred to
        your control (that is, to your crypto-wallet, which is only accessible
        to you via your private key), it becomes 100% yours. Your purchase funds
        will not be refunded or repossessed by W3D Domains. However, if you
        agree to cover the fees associated with transferring the domain back to
        W3D Domains, we can refund the original purchase once the domain is
        received, provided the refund is requested within the timelines above.
        For the avoidance of doubt,{' '}
        <strong>
          refunds to the original payment method will only be available on
          claimed domains if you return the domain to the W3D Domain corporate
          account and pay any blockchain fees or gas fees necessary to transfer
          it back
        </strong>
        . W3D Domains will not refund any such fees.
        <br />
        <br />
        If you wish to receive a refund for the original domain purchase, you
        must transfer the domain back to our corporate account, and forfeit any
        additional promotional credits or items granted in connection with the
        original purchase. The domains you have minted using promotional credit
        must also be returned to our corporate account in order to receive a
        refund.
        <br />
        <br />
        The purchase of promotional credits is NON-REFUNDABLE, and no exchanges
        are permitted. Domains purchased with promotion credits cannot be
        exchanged for alternative or equivalent products, even when a typo is
        made.
        <br />
        <br />
        Preorders, sunrise registrations, and any other early access programs,
        as well as spent domain minting and twitter verification credits, are
        non-refundable.
      </Content>

      <SubTitle>PROHIBITED ACTIVITIES</SubTitle>
      <Content>
        You may not access or use the Site for any purpose other than those for
        which we make it available. We do not endorse or approve any commercial
        endeavors on the Site except those that we expressly endorse.
        <br />
        <br />
        As a user of the Site, you agree not to:
      </Content>
      <ul>
        <li>
          You may not collect, compile, database, or directory data from the
          Site in a systematic manner without our written permission.
        </li>
        <li>
          Make any unauthorized use of the Site, including collecting usernames
          and/or email addresses of users by electronic or other means to send
          unsolicited email or create user accounts by automated means or under
          false pretenses.
        </li>
        <li>
          Circumvent, disable, or otherwise interfere with security­related
          features of the Site, including features that prevent or restrict the
          use or copying of any Content or enforce limitations on the use of the
          Site and/or the Content contained therein.
        </li>
        <li>Engage in unauthorized framing of or linking to the Site.</li>
        <li>
          Trick, defraud, or mislead other users and us, especially in any
          attempt to learn sensitive account information such as user passwords.
        </li>
        <li>
          Make improper use of our support services or submit false reports of
          abuse or misconduct.
        </li>
        <li>
          Automate the use of the system, such as sending comments or messages
          through scripts or collecting data through data mining, robots, or
          similar methods.
        </li>
        <li>
          The Site or the networks or services connected to the Site should not
          be interfered with, disrupted, or burdened by you.
        </li>
        <li>
          Using the username of another user or impersonating another user.
        </li>
        <li>
          Use any information obtained from the Site to harass, abuse, or harm
          another person.
        </li>
        <li>
          Use the Site for any commercial endeavor or revenue-generating
          endeavor, such as competing with us.
        </li>
        <li>
          Decipher, decompile, disassemble, or reverse engineer any of the
          software comprising or in any way making up a part of the Site.
        </li>
        <li>
          Attempt to bypass any measures of the Site designed to prevent or
          restrict access to the Site, or any portion of the Site.
        </li>
        <li>
          Harass, annoy, intimidate, or threaten any of our employees or agents
          engaged in providing any portion of the Site to you.
        </li>
        <li>
          Delete the copyright or other proprietary rights notice from any
          Content.
        </li>
        <li>
          Copy or adapt the Site's software, including but not limited to Flash,
          PHP, HTML, JavaScript, or other code
        </li>
        <li>
          Upload or transmit viruses, Trojan horses, blockchain mining programs,
          or other material that interferes with the uninterrupted use and
          enjoyment of the Site, or alters, impairs, disrupts, or interferes
          with its operation, features, functions, or maintenance.
        </li>
        <li>
          Transmit (or attempt to transmit) any material that collects or
          transmits information passively, such as clear graphics interchange
          formats ("gifs"), 1x1 pixels, web bugs, cookies, or other similar
          devices (sometimes called "spyware" or "passive collection
          mechanisms").
        </li>
        <li>
          A robot, spider, cheat utility, scraper, or offline reader, or any
          unauthorized script that accesses the Site, is prohibited from being
          used, launched, developed, or distributed.
        </li>
        <li>
          We believe the Site and/or us should not be disparaged, tarnished, or
          otherwise harmed.
        </li>
        <li>
          The use of the Site is prohibited by law if it is inconsistent with
          any applicable laws or regulations, notwithstanding that no use is
          prohibited by law that is consistent with the First Amendment to the
          United States Constitution and its <strong>SOCIAL MEDIA</strong>
        </li>
      </ul>
      <Content>
        You may link your account with third-party service providers (each, a
        "Third Party Account") either by: (1) providing your Third Party Account
        login information through the Site; or (2) allowing us access to your
        Third Party Account as permitted by the applicable terms and conditions
        that govern your use of the Third Party Account. You represent and
        warrant that you are entitled to provide us with your Third Party
        Account login information and/or grant us access to your Third Party
        Account, without breaching any of the terms and conditions that govern
        your use of the applicable Third Party Account, and without obligating
        us to pay any fees or making us subject to any usage limitations imposed
        by the third party service provider. By granting us access to any Third
        Party Accounts, you understand that (1) we may access, make available,
        and store (if applicable) any content that you have provided to and
        stored in your Third­ Party Account (the “Social Network Content”) so
        that it is available on and through the Site via your account, including
        without limitation any friend lists and (2) we may submit to and receive
        from your Third­ Party Account additional information to the extent you
        are notified when you link your account with the Third Party Account.
        Depending on the Third Party Accounts you choose and subject to the
        privacy settings that you have set in such Third Party Accounts,
        personally identifiable information that you post to your Third Party
        Accounts may be available on and through your account on the Site.
        Please note that if a Third Party Account or associated service becomes
        unavailable or our access to such Third Party Account is terminated by
        the third party service provider, then Social Network Content may no
        longer be available on and through the Site. You will have the ability
        to disable the connection between your account on the Site and your
        Third Party Accounts at any time. THIRD-PARTY SERVICE PROVIDERS
        ASSOCIATED WITH YOUR THIRD-PARTY ACCOUNTS ARE GOVERNED SOLELY BY YOUR
        AGREEMENT WITH SUCH THIRD-PARTY SERVICE PROVIDERS. We do not review
        Social Network Content for any purpose, including but not limited to
        accuracy, legality, or appropriateness. non­infringement, and we are not
        responsible for any Social Network Content. You acknowledge and agree
        that we may access your email address book associated with a Third Party
        Account and your contacts list stored on your mobile device or tablet
        computer solely for purposes of identifying and informing you of those
        contacts who have also registered to use the Site. You can deactivate
        the connection between the Site and your Third Party Account by
        contacting us using the contact information below or through your
        account settings (if applicable). We will attempt to delete any
        information stored on our servers that was obtained through such Third
        Party Account, except the username and profile picture that become
        associated with your account.
      </Content>

      <SubTitle>SUBMISSIONS</SubTitle>
      <Content>
        Any questions, comments, suggestions, ideas, feedback, or other
        information you provide to us regarding the Site or Marketplace
        Offerings ("Submissions") is non-confidential and becomes our sole
        property. We shall own exclusive rights, including all intellectual
        property rights, to use and distribute these Submissions for any lawful
        purpose, commercial or otherwise, without acknowledgment or compensation
        to you. If you submit any such Submissions, you hereby waive all moral
        rights to such Submissions and warrant that such Submissions are
        original or that you have the right to submit them. It is agreed that
        you will not have any recourse against us in the event that your
        Submissions are alleged or actually infringed or misappropriated.
      </Content>

      <SubTitle>THIRD PARTY WEBSITES AND CONTENT</SubTitle>
      <Content>
        The Site may contain (or you may be sent through the Site or Marketplace
        Offerings) links to other websites ("Third Party Websites") as well as
        articles, photographs, text, graphics, pictures, designs, music, sound,
        video, information, applications, software, and other items from third
        parties ("Third Party Content"). Third Party Websites and Third Party
        Content are not investigated, monitored, or checked by us for accuracy,
        appropriateness, or completeness, and we are not responsible for any
        Third Party Websites or Third Party Content accessed through the Site,
        including their content, accuracy, offensiveness, opinions, reliability,
        privacy practices, or other policies. Our inclusion of, linking to, or
        permitting the use or installation of any Third Party Websites or Third
        Party Content does not imply our approval or endorsement. You should be
        aware that these Terms of Use no longer apply if you leave the Site and
        access Third Party Websites or use or install any Third Party Content.
        In addition to reviewing the terms and policies of any website you
        navigate to from the Site, or of any applications you use or install
        from the Site, you should also review the privacy and data gathering
        policies. Through Third Party Websites, you will make purchases from
        other companies and websites, and we are not responsible for such
        purchases. Unless explicitly stated otherwise, we do not endorse the
        products or services offered on Third Party Websites, and we are not
        responsible for any harm resulting from your purchase. Furthermore, you
        agree to hold us harmless for any losses or harm you may suffer relating
        to or resulting from any Third Party Content or any contact with Third
        Party Websites.
      </Content>

      <SubTitle>ADVERTISERS</SubTitle>
      <Content>
        Advertisers can display their advertisements and other information in
        certain areas of the Site, such as sidebar advertisements or banner
        advertisements. Ads placed on or with the Site (directly or via a third
        party ad disseminator) by advertisers are fully responsible for services
        provided on the Site or products sold through those advertisements.
        Furthermore, as an advertiser, you warrant and represent that you are
        entitled to place advertisements on the Site, including intellectual
        property rights, publicity rights, and contractual rights. We simply
        provide the space to place such advertisements, and we have no other
        relationship with advertisers.
      </Content>

      <SubTitle>SITE MANAGEMENT</SubTitle>
      <Content>
        We reserve the right, but not the obligation, to: (1) monitor the Site
        for violations of these Terms of Use; (2) take appropriate legal action
        against anyone who, in our sole discretion, violates the law or these
        Terms of Use, including without limitation, reporting such user to law
        enforcement authorities; (3) in our sole discretion and without
        limitation, refuse, restrict access to, limit the availability of, or
        disable (to the extent technologically feasible) any of your Domains (if
        in our custody) or Contributions or any portion thereof; (4) in our sole
        discretion and without limitation, notice, or liability, to remove from
        the Site or otherwise disable all files and content that are excessive
        in size or are in any way burdensome to our systems; and (5) otherwise
        manage the Site in a manner designed to protect our rights and property
        and to facilitate the proper functioning of the Site and the Marketplace
        Offerings.
      </Content>

      <SubTitle>PRIVACY POLICY</SubTitle>
      <Content>
        We care about data privacy and security. Please review our Privacy
        Policy:{' '}
        <Link to="/privacy-and-policy" style={{ color: 'blue' }}>
          Privacy Policy
        </Link>{' '}
        By using the Site or the Marketplace Offerings, you agree to be bound by
        our Privacy Policy, which is incorporated into these Terms of Use.
        Please be advised the Site and the Marketplace Offerings are hosted in
        the United States. If you access the Site or the Marketplace Offerings
        from the European Union, Asia, or any other region of the world with
        laws or other requirements governing personal data collection, use, or
        disclosure that differ from applicable laws in the United States, then
        you will be expressly-requested permission to transfer your data to the
        United States and us specifically as a “controller” (or equivalent), or,
        to the extent legally-enforceable, through your continued use of the
        Site, you are thereby transferring your data to the United States, and
        you expressly consent to have your data transferred to and processed in
        the United States and to us in specific. Further, we do not knowingly
        accept, request, or solicit information from children or knowingly
        market to children. Therefore, in accordance with the U.S. Children’s
        Online Privacy Protection Act, if we receive actual knowledge that
        anyone under the age of 13 has provided personal information to us
        without the requisite and verifiable parental consent, we will delete
        that information from the Site as quickly as is reasonably practical.
      </Content>

      <SubTitle>TERM AND TERMINATION</SubTitle>
      <Content>
        These Terms of Use shall remain in full force and effect while you use
        the Site. WITHOUT LIMITING ANY OTHER PROVISION OF THESE TERMS OF USE, WE
        RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND WITHOUT NOTICE OR
        LIABILITY, DENY ACCESS TO AND USE OF THE SITE AND THE MARKETPLACE
        OFFERINGS (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR
        ANY REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR BREACH OF
        ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THESE TERMS OF
        USE OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE YOUR USE OR
        PARTICIPATION IN THE SITE AND THE MARKETPLACE OFFERINGS OR DELETE YOUR
        ACCOUNT AND ANY CONTENT OR INFORMATION THAT YOU POSTED AT ANY TIME,
        WITHOUT WARNING, IN OUR SOLE DISCRETION.
        <br />
        <br />
        It is prohibited for you to register and create a new account under your
        name, a fake or borrowed name, or the name of a third party, even if you
        are acting on behalf of that third party. Furthermore, your account may
        be terminated or suspended, as well as subject to civil, criminal, and
        injunctive remedies.
      </Content>

      <SubTitle>MODIFICATIONS AND INTERRUPTIONS</SubTitle>
      <Content>
        Any part of the Site may be changed, modified, or removed at our sole
        discretion. We are not obligated to update any of the information on our
        Site despite this. Without prior notice, we reserve the right to modify
        or discontinue all or part of the Marketplace Offerings. Modifications,
        price changes, suspensions, or discontinuations of the Site or
        Marketplace Offerings may occur at any time without notice.
        <br />
        <br />
        There is no guarantee that the Site and the Marketplace Offerings will
        always be available. The Site may experience hardware, software, or
        other problems or require maintenance, resulting in interruptions,
        delays, or errors. The Site or the Marketplace Offerings may be changed,
        revised, updated, suspended, discontinued, or otherwise modified at any
        time and without notice to you. During any downtime or discontinuance of
        the Site or Marketplace Offerings, you agree that we are not liable for
        any loss, damage, or inconvenience caused by your inability to access or
        use the Site or Marketplace Offerings. The Terms of Use do not obligate
        us to maintain or support the Site or the Marketplace Offerings, or to
        provide any corrections, updates, or releases associated with them.
      </Content>

      <SubTitle>GOVERNING LAW</SubTitle>
      <Content>
        The Site and the Marketplace Offerings are governed and construed by
        Delaware law, without regard to its conflict of laws principles.
      </Content>

      <SubTitle>DISPUTE RESOLUTION</SubTitle>
      <SubTitle2>Informal Negotiations</SubTitle2>
      <Content>
        Any dispute, controversy, or claim related to these Terms of Use (each a
        "Dispute" and collectively, "Disputes") must be resolved informally for
        at least thirty (30) days before arbitration is initiated by you or us
        (individually, a "Party" and collectively, the "Parties"). A written
        notice is given by one party to the other in such informal negotiations.
      </Content>
      <br />
      <br />

      <SubTitle2>Binding Arbitration</SubTitle2>
      <Content>
        Disputes (except those specifically excluded below) will be resolved
        through binding arbitration if the Parties are unable to resolve them
        through informal negotiations. It would be possible to sue in court
        without this provision, and you would be entitled to a jury trial. The
        AAA Commercial Arbitration Rules and the AAA's Supplementary Procedures
        for Consumer Related Disputes ("AAA Consumer Rules") govern arbitration,
        both of which can be found at the AAA website. Arbitration fees and your
        share of arbitrator compensation will be governed by the AAA Consumer
        Rules and, where appropriate, limited by them. It can be conducted by
        phone, online, through submission of documents, or in person. <br />
        In the absence of a request from either Party, the arbitrator will make
        a written decision without providing reasons. A failure to follow
        applicable law may result in an arbitration award being challenged.
        Unless the AAA rules or applicable law require otherwise, arbitrations
        will generally be held in Clark County, Nevada. A court order can compel
        arbitration, procedures can be stayed pending arbitration, or an
        arbitrator's award may be confirmed, modified, vacated, or judged.{' '}
        <br />
        In the event that a Dispute proceeds in court instead of arbitration,
        the Parties waive any defense based on lack of personal jurisdiction or
        forum non conveniens. These Terms of Use are not governed by the United
        Nations Convention on Contracts for the International Sale of Goods or
        the Uniform Computer Information Transaction Act (UCITA).
        <br />
        <br />
        Any dispute regarding the Site may not be brought by either Party more
        than one (1) year after the cause of action arose. Any Dispute falling
        within the portion of this provision that is illegal or unenforceable
        will not be arbitrated, but rather decided by a court of competent
        jurisdiction within the jurisdictions listed above, and the Parties
        agree to submit to its personal jurisdiction.
      </Content>
      <br />
      <br />

      <SubTitle2>Restrictions</SubTitle2>
      <Content>
        Disputes between the Parties shall only be arbitrated between them
        individually. To the extent permitted by law, there is no right or
        authority for any Dispute to be arbitrated on a class action basis or to
        rely on class action procedures.
      </Content>
      <br />
      <br />

      <SubTitle2>Exceptions to Informal Negotiations and Arbitration</SubTitle2>
      <Content>
        The following Disputes are not subject to the above provisions
        concerning informal negotiations and binding arbitration: (a) any
        Dispute seeking to enforce or protect, or concerning the validity of,
        any intellectual property rights of a Party; and (b) any Dispute
        relating to, or arising from, allegations of theft, piracy, invasion of
        privacy, or unauthorized use. A court of competent jurisdiction within
        the courts listed for jurisdiction above will decide any Dispute falling
        within this provision, and the Parties agree to submit to its personal
        jurisdiction if this provision is found to be illegal or unenforceable.
      </Content>

      <SubTitle>CORRECTIONS</SubTitle>
      <Content>
        Marketplace Offerings, including descriptions, pricing, availability,
        and other information, may contain typographical errors, inaccuracies,
        or omissions. On the Site, we reserve the right to correct any errors,
        inaccuracies, or omissions without prior notice.
      </Content>

      <SubTitle>DISCLAIMER</SubTitle>
      <Content>
        WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, WITH RESPECT TO THE SITE
        AND YOUR USE THEREOF, INCLUDING, WITHOUT LIMITATION, IMPLIED WARRANTIES
        OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NONINFRINGEMENT.
        ABSENCE OF ANY LIABILITY OR responsibility is assumed for (1) errors,
        omissions, or defects of the content and materials (2) personal injury
        or property damage WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF
        THE SITE, (3) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS
        AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION
        STORED THEREIN, (4) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR
        FROM THE SITE, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH
        MAY BE TRANSMITTED TO OR THROUGH THE SITE BY ANY THIRD PARTY, AND/OR (6)
        ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR
        DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT
        POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SITE. WE DO NOT
        WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR
        SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SITE, ANY
        HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION FEATURED IN
        ANY BANNER OR OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO OR IN ANY
        WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND ANY
        THIRD­PARTY PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE PURCHASE OF A
        PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD
        USE YOUR BEST JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE.
      </Content>

      <SubTitle>LIMITATIONS OF LIABILITY</SubTitle>
      <Content>
        YOU OR ANY THIRD PARTY WILL NOT BE LIABLE TO US FOR ANY DIRECT,
        INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE
        DAMAGES ARISING FROM YOUR USE OF THE SITE, EVEN IF WE HAVE BEEN ADVISED
        OF THE POSSIBILITY OF SUCH DAMAGES. NOTWITHSTANDING ANYTHING TO THE
        CONTRARY CONTAINED HEREIN, OUR LIABILITY TO YOU FOR ANY CAUSE WHATSOEVER
        AND REGARDLESS OF THE FORM OF THE ACTION, WILL AT ALL TIMES BE LIMITED
        TO THE AMOUNT PAID, IF ANY, BY YOU TO US DURING THE SIX (6) MONTH PERIOD
        PRIOR TO ANY CAUSE OF ACTION ARISING . A FEW STATE LAWS DO NOT ALLOW
        LIMITATIONS OF IMPLIED WARRANTIES OR EXCLUSION OR LIMITATION OF CERTAIN
        DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE
        DISCLAIMERS OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY HAVE
        ADDITIONAL RIGHTS.
      </Content>

      <SubTitle>INDEMNIFICATION</SubTitle>
      <Content>
        You agree to defend, indemnify, and hold us harmless, including our
        subsidiaries, affiliates, and all of our respective officers, agents,
        partners, and employees, from and against any loss, damage, liability,
        claim, or demand, including reasonable attorneys’ fees and expenses,
        made by any third party due to or arising out of: (1) use of the Site;
        (2) breach of these Terms of Use; (3) any breach of your representations
        and warranties set forth in these Terms of Use; (4) your violation of
        the rights of a third party, including but not limited to intellectual
        property rights; (5) our blocking or deletion of any Domain in custody
        with us or other information in such Domain record in accordance with
        this Agreement; (6) any malfunction, damage or disruption to any public
        blockchain network, or (6) any overt harmful act toward any other user
        of the Site with whom you connected via the Site. Notwithstanding the
        foregoing, we reserve the right, at your expense, to assume the
        exclusive defense and control of any matter for which you are required
        to indemnify us, and you agree to cooperate, at your expense, with our
        defense of such claims. We will use reasonable efforts to notify you of
        any such claim, action, or proceeding which is subject to this
        indemnification upon becoming aware of it.
      </Content>

      <SubTitle>USER DATA</SubTitle>
      <Content>
        We will maintain certain data that you transmit to the Site for the
        purpose of managing the performance of the Site, as well as data
        relating to your use of the Site. Although we perform regular routine
        backups of data, you are solely responsible for all data that you
        transmit or that relates to any activity you have undertaken using the
        Site. You agree that we shall have no liability to you for any loss or
        corruption of any such data, and you hereby waive any right of action
        against us arising from any such loss or corruption of such data.
        <br />
        <br />
        Notwithstanding any privacy-related laws or regulations to the contrary,{' '}
        <strong>
          we will not and cannot delete any data you have provided to us which
          is subsequently recorded to the blockchain or any other distributed
          decentralized storage networks
        </strong>
        . You agree, to the extent you have instructed us, whether explicitly or
        implicitly (i.e., by submitting it to us through our web portal) to
        so-record such information, to hold us harmless and indemnify us (in the
        manner of the previous section) for any claims or damages founded upon
        the publication of and/or the inability to delete such information. The
        indemnification of the previous section shall be construed to include
        and encompass any third-party damages or claims founded upon your
        submission of data to us which cannot subsequently be removed or
        deleted.
      </Content>

      <SubTitle>
        ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES
      </SubTitle>
      <Content>
        Visiting the Site, sending us emails, and completing online forms
        constitute electronic communications. You hereby consent to receive
        electronic communications from us, and you agree that all agreements,
        notices, disclosures, and other communications we provide to you
        electronically, via email and on the Site, satisfy any legal requirement
        that such communication be in writing. YOU HEREBY AGREE TO THE USE OF
        ELECTRONIC SIGNATURES, ORDERS, AND OTHER RECORDS, AND TO THE ELECTRONIC
        DELIVERY OF NOTICES, POLICIES, AND RECORDS OF TRANSACTIONS INITIATED OR
        COMPLETED BY US OR VIA THE SITE. You waive any rights you might have
        under any statutes, regulations, rules, ordinances, or other laws in any
        jurisdiction that require an original signature or
      </Content>

      <SubTitle>CALIFORNIA USERS AND RESIDENTS</SubTitle>
      <Content>
        For any complaints with us that are not satisfactorily resolved, you may
        contact the Complaint Assistance Unit of the Division of Consumer
        Services of the California Department of Consumer Affairs by writing at
        1625 North Market Blvd., Suite N 112, Sacramento, California 95834 or by
        telephone at (800) 952-5210 or (916) 445-1254.
      </Content>

      <SubTitle>STORE CREDIT POLICY</SubTitle>
      <Content>
        Any refunds, if granted, are made as a prepaid amount to your profile on
        our website, and these amounts do not expire. Store credit issued to you
        as part of an W3D Domains customer loyalty program or promotional gift
        will expire in the time period stated in the email or other notification
        you receive regarding the store credit. The notification may contain
        other terms and conditions that will also apply. No service fees,
        dormancy fees, or other fees will be charged for the redemption of store
        credit. Unless required by law, store credit cannot be redeemed for cash
        and is non-transferable.
        <br />
        To apply your store credit to a future purchase or to inquire about the
        balance of store credit on your profile, please contact us by email at{' '}
        <span style={{ color: 'blue' }}>support@w3ddomains.com</span>.
      </Content>

      <SubTitle>PROTECTED BRANDS POLICY</SubTitle>
      <Content>
        In addition to these Terms of Use, if you claim a protected domain
        pursuant to the Protected Brands Policy, you will also be subject to the
        terms of the Protected Brands Policy.
        <br />
        <br />
        Under the Protected Brands Policy, W3D Domains will grant the claiming
        company a limited, non-exclusive, royalty-free, fully paid up, worldwide
        license to use, reproduce, publish, and distribute its name, primary
        trademarks, and logos for publicity purposes.
      </Content>

      <SubTitle>MISCELLANEOUS</SubTitle>
      <Content>
        All policies and operating rules posted by us on the Site or in respect
        to the Site constitute the entire agreement and understanding between
        you and us. The failure of us to exercise or enforce any right or
        provision of these Terms of Use shall not be construed as a waiver of
        such right or provision. These Terms of Use operate to the fullest
        extent permissible by law. We may assign any or all of our rights and
        obligations to others at any time. We shall not be responsible or liable
        for any loss, damage, delay, or failure to act caused by any cause
        beyond our reasonable control. If any provision or part of a provision
        of these Terms of Use is determined to be unlawful, void, or
        unenforceable, that provision or part of the provision is deemed
        severable from these Terms of Use and does not affect the validity and
        enforceability of any remaining provisions. As a result of these Terms
        of Use or use of the Site, you and us do not have any joint venture,
        partnership, employment or agency relationship. You agree that these
        Terms of Use will not be construed against us by virtue of having
        drafted them. You hereby waive any and all defenses you may have based
        on the electronic form of these Terms of Use and the lack of signing by
        the parties hereto to execute these Terms of Use.
        <br />
        <br />
        Please read these Terms of Service (the “Terms”) carefully as they form
        a contract between you and W3D Domains Inc., a Delaware corporation
        (“UD”; “us”; “our”) that governs your access and use of our application,
        our services, and other software that may be downloaded to, or accessed
        by, any mobile or computing device you own or control in connection with
        our services (collectively, the “Services”).
        <br />
        <br />
        By using, accessing, or downloading the Services, you are agreeing to
        these Terms. You may not use, access, or download the Services unless,
        and by accessing the Services you represent and warrant that, you (1) if
        an individual, are at least 13 years of age, (2) have not at any time
        breached a contract with UD, and (3) accept and agree to be bound by
        these Terms.
        <br />
        <br />
        These Terms together with our Privacy Policy constitute the entire
        agreement between you and us, regarding your access to, and use of, any
        Services.
      </Content>
      <ol>
        <li>
          Account Registration. To create an account, you must register for the
          Services using your phone number. You agree to receive text messages
          and phone calls (from us or our third-party providers) with
          verification codes to register for our Services.
        </li>
        <li>
          Software. In order to enable new features and enhanced functionality,
          you consent to downloading and installing updates to our Services.
        </li>
        <li>
          Fees and Taxes. You are responsible for data and mobile carrier fees
          and taxes associated with the devices on which you use our Services.
        </li>
        <li>
          Your Responsibilities and Restrictions. You are solely responsible for
          your actions. You agree:
        </li>
        <ol className="alphabet">
          <li>
            comply with all applicable local, state, national, and international
            laws and regulations;
          </li>
          <li>Observe all export control and trade sanctions laws;</li>
          <li>
            Not to violate or infringe upon UD, our users, or others' rights,
            including privacy, publicity, intellectual property, or other
            proprietary rights;
          </li>
          <li>
            Distribution of viruses, corrupted files, or any other software code
            that may damage the operation of the Services or other computers or
            facilities is prohibited;
          </li>
          <li>
            Do not interfere with or disrupt networks or facilities used in
            providing or connected to the Services;
          </li>
          <li>
            not to transmit or post any material that encourages conduct that
            could constitute a criminal offense or give rise to civil liability;
          </li>
          <li>
            not to interfere with any other customer’s use and enjoyment of the
            Services;
          </li>
          <li>
            not to transmit any content that is libelous, defamatory, obscene,
            pornographic, abusive, or threatening;
          </li>
          <li>
            not to send illegal or impermissible communications such as bulk
            messaging, auto-messaging, and auto-dialing;
          </li>
          <li>
            not to gain or try to gain unauthorized access to our Services or
            systems;
          </li>
          <li>
            not to reverse engineer, decompile, disassemble or otherwise attempt
            to discover the source code underlying our Services;
          </li>
          <li>not to disrupt the integrity or performance of our Services;</li>
          <li>
            not to create accounts for our Services through unauthorized or
            automated means;
          </li>
          <li>
            install or use a copy of the Services on a device that you do not
            own or control;
          </li>
          <li>
            not to collect information about our users in any unauthorized
            manner;
          </li>
          <li>not to sell, rent, or charge for our Services; and</li>
          <li>
            to comply with all material and applicable regulations, policies and
            procedures of networks connected to the Services.
          </li>
          <Content>
            You acknowledge that the laws and regulations governing the use of
            the Services may change from time to time. If we disable your
            account for a violation of our Terms, you will not create another
            account without our written consent
          </Content>
        </ol>
        <li>
          Communications and Assumption of Risk. UD neither endorses nor assumes
          any responsibility for the content of communications made by its
          customers, nor for the time, place, manner, or contents of those
          communications. Communication between customers cannot be accessed by
          UD. All risks associated with your communications via the Services are
          solely your responsibility.
        </li>
        <li>
          Keeping Your Account Secure. UD does not have the ability to access
          your messages. You are responsible for keeping your device and your UD
          account safe and secure.
        </li>
        <li>
          No Access to Emergency Services. Our Services do not provide access to
          emergency service providers like the police, fire department,
          hospitals, or other public safety organizations. Make sure you can
          contact emergency service providers through a mobile, fixed-line
          telephone, or other service.
        </li>
        <li>
          Third-Party Services. Our Services may allow you to access, use, or
          interact with third-party websites, apps, content, and other products
          and services. When you use third-party services, their terms and
          privacy policies govern your use of those services.
        </li>
        <li>
          Your Rights. You own the information you submit through our Services.
          You must have the rights to the phone number you use to sign up for
          your UD account.
        </li>
        <li>
          UD’s Rights. We own all copyrights, trademarks, domains, logos, trade
          dress, trade secrets, patents, and other intellectual property rights
          associated with our Services. You may not use our copyrights,
          trademarks, domains, logos, trade dress, patents, and other
          intellectual property rights unless you have our written permission.
          To report copyright, trademark, or other intellectual property
          infringement, please contact{' '}
          <span style={{ color: 'blue' }}>legal@w3ddomains.com</span>.
        </li>
        <li>
          UD’s License to You. UD grants you a limited, revocable,
          non-exclusive, and non-transferable license to use our Services in
          accordance with these Terms.
        </li>
        <li>
          Disclaimers. YOU USE OUR SERVICES AT YOUR OWN RISK AND SUBJECT TO THE
          FOLLOWING DISCLAIMERS. WE PROVIDE OUR SERVICES ON AN “AS IS” BASIS
          WITHOUT ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED
          TO, WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
          TITLE, NON-INFRINGEMENT, AND FREEDOM FROM COMPUTER VIRUS OR OTHER
          HARMFUL CODE. UD DOES NOT WARRANT THAT ANY INFORMATION PROVIDED BY US
          IS ACCURATE, COMPLETE, OR USEFUL, THAT OUR SERVICES WILL BE
          OPERATIONAL, ERROR-FREE, SECURE, OR SAFE, OR THAT OUR SERVICES WILL
          FUNCTION WITHOUT DISRUPTIONS, DELAYS, OR IMPERFECTIONS. WE DO NOT
          CONTROL, AND ARE NOT RESPONSIBLE FOR, CONTROLLING HOW OR WHEN OUR
          USERS USE OUR SERVICES. WE ARE NOT RESPONSIBLE FOR THE ACTIONS OR
          INFORMATION (INCLUDING CONTENT) OF OUR USERS OR OTHER THIRD PARTIES.
          YOU RELEASE US, AFFILIATES, DIRECTORS, OFFICERS, EMPLOYEES, PARTNERS,
          AND AGENTS (TOGETHER, “UD PARTIES”) FROM ANY CLAIM, COMPLAINT, CAUSE
          OF ACTION, CONTROVERSY, OR DISPUTE (TOGETHER, “CLAIM”) AND DAMAGES,
          KNOWN AND UNKNOWN, RELATING TO, ARISING OUT OF, OR IN ANY WAY
          CONNECTED WITH ANY SUCH CLAIM YOU HAVE AGAINST ANY THIRD PARTIES.
        </li>
        <li>
          Limitation of Liability. WE ARE NOT LIABLE FOR ANY LOST PROFITS OR
          CONSEQUENTIAL, SPECIAL, PUNITIVE, INDIRECT, OR INCIDENTAL DAMAGES
          RELATING TO, ARISING OUT OF, OR IN ANY WAY CONNECTED WITH OUR TERMS,
          US, OR OUR SERVICES, EVEN IF THE UD PARTIES HAVE BEEN ADVISED OF THE
          POSSIBILITY OF SUCH DAMAGES. CERTAIN DAMAGES ARE DISCLAIMED AND
          LIMITATIONS OF LIABILITY ARE LIMITED TO THE MAXIMUM EXTENT PERMITTED
          BY APPLICABLE LAW. CERTAIN STATES AND JURISDICTIONS MAY NOT ALLOW THE
          EXCLUSION OR LIMITATION OF CERTAIN DAMAGES, SO SOME OR ALL OF THE
          EXCLUSIONS AND LIMITATIONS SET FORTH ABOVE MAY NOT APPLY TO YOU.
        </li>
        <li>
          Indemnification. Indemnify and hold harmless (and, if UD requests,
          defend) UD, its parent organizations, subsidiaries, other corporate
          affiliates, and licensors, as well as their respective officers,
          directors, employees, attorneys, and agents from and against any and
          all claims, costs, damages, losses, liabilities, and expenses arising
          out of or in connection with any claim alleging or based on any facts
          that constitute a violation by you of any of your covenants,
          representations, or warranties in this Agreement.
        </li>
        <li>
          Availability. Occasionally, our Services may be interrupted for
          maintenance, upgrades, or equipment failures. Occasionally, we may
          discontinue some or all of our Services, including certain features
          and support for certain devices and platforms.
        </li>
        <li>
          Ending These Terms. By deleting the UD application from your device
          and discontinuing use of our Services, you can terminate these Terms
          at any time. Any time and for any reason, including, without
          limitation, if you violate our Terms, we may modify, suspend, or
          terminate your access to or use of our Services. The following
          sections will survive termination of your relationship with UD:
          Sections 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14, 15, 16, 17, and 18.
        </li>
        <li>General.</li>
        <ol className="alphabet">
          <li>
            No Waiver. If we fail to enforce any of our Terms, that does not
            mean we waive the right to enforce them.
          </li>
          <li>
            Severability. If any provision of the Terms is deemed unlawful,
            void, or unenforceable, that provision shall be deemed severable
            from our Terms and shall not affect the enforceability of the
            remaining provisions.
          </li>
          <li>
            Restricted countries. It is not our intention to distribute or use
            our Services in any country where such distribution or use would
            violate local law or subject us to local regulations.It is not our
            intention to distribute or use our Services in any country where
            such Distribution or use of our Services in any country that would
            violate local law or subject us to local regulations is not
            intended.
          </li>
          <li>
            Questions. If you have specific questions about these Terms, please
            contact us at{' '}
            <span style={{ color: 'blue' }}>legal@w3ddomains.com</span>.
          </li>
        </ol>
      </ol>

      <SubTitle>CONTACT US</SubTitle>
      <Content>
        In order to resolve a complaint regarding the Site or to receive further
        information regarding use of the Site, please contact us at:
        <br />
        <br />
        <strong>W3D Domains Inc.</strong>
        <br />
        <strong>W3D contact details</strong>
        <br />
        <strong>Email:&nbsp;</strong>
        <span style={{ color: 'blue' }}>legal@w3ddomains.com</span>
      </Content>
    </Wrapper>
  </ScrollToTop>
)

export default TermsOfUse

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 80px 24px;

  ${mq.medium`
    margin: 80px 40px;
  `}

  ${mq.large`
    margin: 80px 64px;
  `}

  ${mq.xLarge`
    margin: 80px 84px;
  `}

  ul,
  ol {
    margin: 0;
  }

  li {
    margin: 20px 0;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.15px;
  }

  .alphabet {
    li {
      list-style-type: lower-alpha;
    }
  }
`

const Title = styled('div')`
  margin: 0 auto;
  font-weight: 700;
  font-family: Poppins;
  font-size: 36px;
  line-height: 116.7%;

  ${mq.medium`
    font-size: 48px;
  `}
`

const SubTitle = styled('div')`
  margin-top: 50px;
  margin-bottom: 20px;
  font-weight: 700;
  font-family: Poppins;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.25px;
`

const SubTitle2 = styled('div')`
  font-weight: 700;
  font-family: Poppins;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: -0.015rem;
`

const Content = styled('p')`
  font-weight: 400;
  font-family: Poppins;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.15px;
  text-align: left;
`
